import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Mark from './Mark';
import '../styles/nav.css';

const LINKS = [
  { label: 'The problem', to: '/#problem' },
  { label: 'What we sell', to: '/#offer' },
  { label: 'The guarantee', to: '/#guarantee' },
  { label: 'Process', to: '/#process' },
  { label: 'Blog', to: '/blog' },
];

function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Hairline only appears once the page has moved, so the hero reads as one
  // uninterrupted field at rest.
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Any navigation closes the mobile menu.
  useEffect(() => {
    setOpen(false);
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <header className={`nav${scrolled ? ' nav--scrolled' : ''}`}>
      <div className="wrap nav-inner">
        <Link to="/" className="nav-brand" aria-label="Zenbul home">
          <Mark size={36} />
          <span className="nav-wordmark">Zenbul</span>
        </Link>

        <nav className="nav-links" aria-label="Main">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} className="nav-link">
              {l.label}
            </Link>
          ))}
        </nav>

        <Link to="/#assessment" className="btn btn--primary nav-cta">
          Request a site assessment
        </Link>

        <button
          type="button"
          className="nav-toggle"
          aria-expanded={open}
          aria-controls="nav-mobile"
          onClick={() => setOpen((v) => !v)}
        >
          <span className="sr-only">{open ? 'Close menu' : 'Open menu'}</span>
          <span className={`nav-toggle-bar${open ? ' is-open' : ''}`} aria-hidden="true" />
          <span className={`nav-toggle-bar${open ? ' is-open' : ''}`} aria-hidden="true" />
        </button>
      </div>

      <div id="nav-mobile" className={`nav-mobile${open ? ' is-open' : ''}`} hidden={!open}>
        {LINKS.map((l) => (
          <Link key={l.to} to={l.to} className="nav-mobile-link">
            {l.label}
          </Link>
        ))}
        <Link to="/#assessment" className="btn btn--primary nav-mobile-cta">
          Request a site assessment
        </Link>
      </div>
    </header>
  );
}

export default Nav;
